import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "envio-list-container" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  class: "accordion",
  id: "accordionFaq"
}

import { useEnviosStore } from '@/stores/useEnvioStore';
import IncidentDetailComponent from './IncidentDetailComponent.vue';
import { Envio } from '@/types/envioTypes';
//import PaginationControls from '@/core/components/PaginationControls.vue';
import { onMounted } from 'vue';
import EnvioItemComponent from './EnvioItemComponent.vue';
import { Calculator, Store, CalendarClock, SquareCheck, KeyRound, Pencil } from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'EnvioListComponent',
  setup(__props) {

const store = useEnviosStore();

// Carga inicial
onMounted(async () => {
  if (!store.envios.length) {
    await store.fetchEnvios();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_class = _resolveComponent("class")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_class, { class: "row" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(KeyRound)),
          _cache[0] || (_cache[0] = _createTextVNode(" ID "))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Store)),
          _cache[1] || (_cache[1] = _createTextVNode(" Expendeduria "))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(SquareCheck)),
          _cache[2] || (_cache[2] = _createTextVNode(" Estado "))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(CalendarClock)),
          _cache[3] || (_cache[3] = _createTextVNode(" Fecha "))
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).sortedEnvios, (envio) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(EnvioItemComponent), {
              key: envio.id,
              envio: envio
            }, null, 8, ["envio"]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})